<mat-form-field class="grow form-field" color="accent">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option *ngIf="!control.value" [value]="null"></mat-option>
    <mat-option *ngFor="let item of items" [value]="item.id">
      {{ item.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
